import { AppLanguage, IUfinetSelectOption } from 'ufinet-web-functions'

export class ProjectType {
	projectTypeId: string
	nameEs: string
	nameEn: string
	namePt: string

	constructor(id: string, nameEs: string, nameEn: string, namePt: string) {
		this.projectTypeId = id
		this.nameEs = nameEs
		this.nameEn = nameEn
		this.namePt = namePt
	}

	static mapProjectTypeToSelectOption(self: ProjectType, language: AppLanguage): IUfinetSelectOption {
		return {
			label: language === 'es' ? self.nameEs : language === 'en' ? self.nameEn : self.namePt,
			value: self.projectTypeId,
		}
	}
}
